import type {
  MFAIdentityType,
  SendMfaOtpCodeRequestDto,
  SendMfaOtpCodeResponseDto,
} from '@/entities/mfa-identity';
import { apiClient, handleRequest } from '@/shared/api';
import type {
  GetTwoFactorAppKeyResponseDto,
  EnableTwoFactorIdentityRequestDto,
  EnableTwoFactorIdentityResponseDto,
  DisableTwoFactorIdentityRequestDto,
  DisableTwoFactorIdentityResponseDto,
} from './types';

export const getTwoFactorAppKey = async () => {
  const request = () =>
    apiClient.get(`/security/twofa/googleauthenticator/newkey`);
  const response = await handleRequest<GetTwoFactorAppKeyResponseDto>(request);
  return response.data;
};

export const sendTwoFactorIdentityCode = async (
  args: SendMfaOtpCodeRequestDto
) => {
  const request = () => apiClient.post(`/security/otp/send`, args);
  const response = await handleRequest<SendMfaOtpCodeResponseDto>(request);
  return response.data;
};

export const enableTwoFactorIdentity = async (
  identityType: MFAIdentityType,
  args: EnableTwoFactorIdentityRequestDto
) => {
  const request = () =>
    apiClient.post(`/security/twofa/${identityType}/enable`, args);
  const response = await handleRequest<EnableTwoFactorIdentityResponseDto>(
    request,
    { throwOriginalError: true }
  );
  return response.data;
};

export const disableTwoFactorIdentity = async (
  identityType: MFAIdentityType,
  twoFaState: DisableTwoFactorIdentityRequestDto | Record<string, never>
) => {
  const request = () =>
    apiClient.post(`/security/twofa/${identityType}/disable`, twoFaState);
  const response = await handleRequest<DisableTwoFactorIdentityResponseDto>(
    request,
    { throwOnError: false }
  );
  return response.data;
};
